


import SECTION_1676511135550 from
'../dynamic_section/dynamic_2/template_01';






import HowItWorkSection from '../sections/how_it_work/template_01';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const HowItWorkPage = ()=>{
return (
  <div id="howItWorkPage" class="page bg_global">
  
  

  
  < SECTION_1676511135550 desktopToggle={ true }
    mobileToggle={ false } label={ `tnc_title` } id={ `howitwork_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  < SECTION_1676511135550 desktopToggle={ false }
    mobileToggle={ true } label={ `tnc_title` } id={ `howitwork_title_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  

  
  <HowItWorkSection desktopTitleToggle={ false }
    mobileTitleToggle={ true } />
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `mall_step` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  < SECTION_FOOTER_BANNER desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `mall_step_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
</div>
)
}

export default HowItWorkPage;